import { render } from "./SiteHeaderMenuIcon.vue?vue&type=template&id=19985a8e"
const script = {}

import "./SiteHeaderMenuIcon.vue?vue&type=style&index=0&id=19985a8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__